/* eslint-disable max-lines -- one endpoint table for the storage API domain; declarations only */
import type {
  FacilityTransferDayPublicGetApiData,
  FacilityTransferDayPublicGetApiResponses,
  FacilityTransferExternalCheckBulkPublicApiData,
  FacilityTransferExternalCheckBulkPublicApiResponses,
  GaragePickingListApiData,
  GaragePickingListApiResponses,
  LabelPrintRequestCancelApiData,
  LabelPrintRequestCancelApiResponses,
  LabelPrintRequestCreateApiData,
  LabelPrintRequestCreateApiResponses,
  LabelPrintRequestListApiData,
  LabelPrintRequestListApiResponses,
  LabelPrintRequestMarkPrintedApiData,
  LabelPrintRequestMarkPrintedApiResponses,
  ShopInventoryOrderCarTireQuotesListApiData,
  ShopInventoryOrderCarTireQuotesListApiResponses,
  StorageAreaCreateApiData,
  StorageAreaCreateApiResponses,
  StorageAreaDeleteApiData,
  StorageAreaDeleteApiResponses,
  StorageAreaListApiData,
  StorageAreaListApiResponses,
  StorageAreaOverviewListApiData,
  StorageAreaOverviewListApiResponses,
  StorageAreaPatchApiData,
  StorageAreaPatchApiResponses,
  StorageAreasForStorageFacilityListApiData,
  StorageAreasForStorageFacilityListApiResponses,
  StorageAreaUnitSpaceSetApiData,
  StorageAreaUnitSpaceSetApiResponses,
  StorageCarWheelSetListApiData,
  StorageCarWheelSetListApiResponses,
  StorageCountLineListApiData,
  StorageCountLineListApiResponses,
  StorageCountLineScanApiData,
  StorageCountLineScanApiResponses,
  StorageCountSessionCancelApiData,
  StorageCountSessionCancelApiResponses,
  StorageCountSessionCompleteApiData,
  StorageCountSessionCompleteApiResponses,
  StorageCountSessionCreateApiData,
  StorageCountSessionCreateApiResponses,
  StorageCountSessionGetApiData,
  StorageCountSessionGetApiResponses,
  StorageCountSessionListApiData,
  StorageCountSessionListApiResponses,
  StorageFacilityArchiveApiData,
  StorageFacilityArchiveApiResponses,
  StorageFacilityCreateApiData,
  StorageFacilityCreateApiResponses,
  StorageFacilityGetApiData,
  StorageFacilityGetApiResponses,
  StorageFacilityGoogleOpeningHoursPostApiData,
  StorageFacilityGoogleOpeningHoursPostApiResponses,
  StorageFacilityListApiData,
  StorageFacilityListApiResponses,
  StorageFacilityOpeningHoursCreateApiData,
  StorageFacilityOpeningHoursCreateApiResponses,
  StorageFacilityOpeningHoursUpdateApiData,
  StorageFacilityOpeningHoursUpdateApiResponses,
  StorageFacilityOverviewListApiData,
  StorageFacilityOverviewListApiResponses,
  StorageFacilityPatchApiData,
  StorageFacilityPatchApiResponses,
  StorageFacilityPublicHolidayOpeningHoursPostApiData,
  StorageFacilityPublicHolidayOpeningHoursPostApiResponses,
  StorageFacilityUnarchiveApiData,
  StorageFacilityUnarchiveApiResponses,
  StorageLabelReplacedApiData,
  StorageLabelReplacedApiResponses,
  StorageMountTiresOnWheelsAtStorageFacilityApiData,
  StorageMountTiresOnWheelsAtStorageFacilityApiResponses,
  StorageObjectCarTiresApiData,
  StorageObjectCarTiresApiResponses,
  StorageObjectCarWheelsListApiData,
  StorageObjectCarWheelsListApiResponses,
  StorageObjectCreateForTireQuoteApiData,
  StorageObjectCreateForTireQuoteApiResponses,
  StorageObjectEventGetApiData,
  StorageObjectEventGetApiResponses,
  StorageObjectEventListApiData,
  StorageObjectEventListApiResponses,
  StorageObjectEventRetractPreviewApiData,
  StorageObjectEventRetractPreviewApiResponses,
  StorageObjectEventsRetractApiData,
  StorageObjectEventsRetractApiResponses,
  StorageObjectGroupByIdentifiersDetailsApiData,
  StorageObjectGroupByIdentifiersDetailsApiResponses,
  StorageObjectGroupCreateForWheelSetsBulkApiData,
  StorageObjectGroupCreateForWheelSetsBulkApiResponses,
  StorageObjectGroupCurrentIdentifiersApiData,
  StorageObjectGroupCurrentIdentifiersApiResponses,
  StorageObjectGroupEventListApiData,
  StorageObjectGroupEventListApiResponses,
  StorageObjectGroupGetApiData,
  StorageObjectGroupGetApiResponses,
  StorageObjectGroupGetByIdentifierApiData,
  StorageObjectGroupGetByIdentifierApiResponses,
  StorageObjectGroupListApiData,
  StorageObjectGroupListApiResponses,
  StorageObjectGroupListV2ApiData,
  StorageObjectGroupListV2ApiResponses,
  StorageObjectGroupListV2ToExcelApiData,
  StorageObjectGroupListV2ToExcelApiResponses,
  StorageObjectGroupPatchApiData,
  StorageObjectGroupPatchApiResponses,
  StorageObjectGroupPostBulkApiData,
  StorageObjectGroupPostBulkApiResponses,
  StorageObjectGroupPrepareForGarageApiData,
  StorageObjectGroupPrepareForGarageApiResponses,
  StorageObjectGroupsInventoryOrdersReceiveApiData,
  StorageObjectGroupsInventoryOrdersReceiveApiResponses,
  StorageObjectGroupTransferSuggestionsApiData,
  StorageObjectGroupTransferSuggestionsApiResponses,
  StorageObjectGroupWithBookingInfoListApiData,
  StorageObjectGroupWithBookingInfoListApiResponses,
  StorageTransferOrderAddWheelSetsApiData,
  StorageTransferOrderAddWheelSetsApiResponses,
  StorageTransferOrderAddWheelSetsPreviewApiData,
  StorageTransferOrderAddWheelSetsPreviewApiResponses,
  StorageTransferOrderBulkCreateApiData,
  StorageTransferOrderBulkCreateApiResponses,
  StorageTransferOrderCancelApiData,
  StorageTransferOrderCancelApiResponses,
  StorageTransferOrderCreateApiData,
  StorageTransferOrderCreateApiResponses,
  StorageTransferOrderDeleteApiData,
  StorageTransferOrderDeleteApiResponses,
  StorageTransferOrderDispatchApiData,
  StorageTransferOrderDispatchApiResponses,
  StorageTransferOrderDispatchPreviewApiData,
  StorageTransferOrderDispatchPreviewApiResponses,
  StorageTransferOrderDispatchPreviewForOrderApiData,
  StorageTransferOrderDispatchPreviewForOrderApiResponses,
  StorageTransferOrderFacilityLinkPublicGetApiData,
  StorageTransferOrderFacilityLinkPublicGetApiResponses,
  StorageTransferOrderGetApiData,
  StorageTransferOrderGetApiResponses,
  StorageTransferOrderItemOutcomeSetApiData,
  StorageTransferOrderItemOutcomeSetApiResponses,
  StorageTransferOrderItemsUnableToCompleteBulkApiData,
  StorageTransferOrderItemsUnableToCompleteBulkApiResponses,
  StorageTransferOrderItemsUpdateApiData,
  StorageTransferOrderItemsUpdateApiResponses,
  StorageTransferOrderItemUnableToCompleteClearApiData,
  StorageTransferOrderItemUnableToCompleteClearApiResponses,
  StorageTransferOrderListApiData,
  StorageTransferOrderListApiResponses,
  StorageTransferOrderRecordPatch,
  StorageTransferOrderStatus,
  StorageTransferOrderUpdateApiResponses,
  StorageTransferTimingPreviewApiData,
  StorageTransferTimingPreviewApiResponses,
  StorageUnitCreateApiData,
  StorageUnitCreateApiResponses,
  StorageUnitDeleteApiData,
  StorageUnitDeleteApiResponses,
  StorageUnitGetApiData,
  StorageUnitGetApiResponses,
  StorageUnitListApiData,
  StorageUnitListApiResponses,
  StorageUnitObjectsExcelDownloadApiData,
  StorageUnitObjectsExcelDownloadApiResponses,
  StorageUnitPatchApiData,
  StorageUnitPatchApiResponses,
  StorageUnitsByAreaIdentifierListApiData,
  StorageUnitsByAreaIdentifierListApiResponses,
  WheelStorageCarChangeApiData,
  WheelStorageCarChangeApiResponses,
  WheelStorageForCustomerListApiData,
  WheelStorageForCustomerListApiResponses,
  WheelStorageOverviewGetApiData,
  WheelStorageOverviewGetApiResponses
} from '@navio/nsdk';

import { downloadToExcel } from '../../downloadToExcel';
import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';
import { storageObjectGroupsListQueryParamsForUrl } from './objectGroupListQueryParams';
import { getUnlockUrls } from './unlockUrls';

/**
 * nsdk 0.245 dropped status from the transfer-order PATCH body, but the API still
 * accepts it. Local shape keeps FE typed.
 */
type StorageTransferOrderUpdateApiData = {
  body?: (StorageTransferOrderRecordPatch & { status?: StorageTransferOrderStatus }) | null;
  path: { storageTransferOrderId: number };
  query?: never;
  url: '/v1/storage-transfer-orders/{storage_transfer_order_id}/';
};

export const getStorageUrls = {
  getPaginatedStorageFacilities: dataEndpoint<StorageFacilityListApiData, StorageFacilityListApiResponses>({
    getUrl: (queryParams) => apiUrl('storage-facilities/', queryParams)
  }),
  getStorageFacilitiesOverview: dataEndpoint<
    StorageFacilityOverviewListApiData,
    StorageFacilityOverviewListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('storage-facilities/overview/', queryParams)
  }),
  getStorageFacility: dataEndpoint<StorageFacilityGetApiData, StorageFacilityGetApiResponses>({
    getUrl: ({ storageFacilityId }) => apiUrl(`storage-facilities/${storageFacilityId}/`)
  }),
  postStorageFacilityArchive: responseEndpoint<StorageFacilityArchiveApiData, StorageFacilityArchiveApiResponses>({
    getUrl: ({ storageFacilityId }) => apiUrl(`storage-facilities/${storageFacilityId}/archive/`)
  }),
  postStorageFacilityUnarchive: responseEndpoint<StorageFacilityUnarchiveApiData, StorageFacilityUnarchiveApiResponses>(
    {
      getUrl: ({ storageFacilityId }) => apiUrl(`storage-facilities/${storageFacilityId}/unarchive/`)
    }
  ),
  getGaragePickingList: dataEndpoint<GaragePickingListApiData, GaragePickingListApiResponses>({
    getUrl: ({ storageFacilityId, ...queryParams }) =>
      apiUrl(`storage-facilities/${storageFacilityId}/garage-picking-list/`, queryParams)
  }),
  postStorageObjectGroupPrepareForGarage: responseEndpoint<
    StorageObjectGroupPrepareForGarageApiData,
    StorageObjectGroupPrepareForGarageApiResponses
  >({
    getUrl: ({ storageObjectGroupIdentifier }) =>
      apiUrl(`storage-object-groups/${storageObjectGroupIdentifier}/prepare-for-garage/`),
    getBody: ({ storageObjectGroupIdentifier: _, ...body }) => body
  }),
  postStorageFacility: responseEndpoint<StorageFacilityCreateApiData, StorageFacilityCreateApiResponses>({
    getUrl: () => apiUrl('storage-facilities/'),
    getBody: (data) => data
  }),
  patchStorageFacility: responseEndpoint<StorageFacilityPatchApiData, StorageFacilityPatchApiResponses>({
    getUrl: ({ storageFacilityId }) => apiUrl(`storage-facilities/${storageFacilityId}/`),
    getBody: ({ storageFacilityId: _, ...body }) => body
  }),
  getStorageAreasOverview: dataEndpoint<StorageAreaOverviewListApiData, StorageAreaOverviewListApiResponses>({
    getUrl: (queryParams) => apiUrl('storage-areas/overview/', queryParams)
  }),
  getStorageAreasForFacility: dataEndpoint<
    StorageAreasForStorageFacilityListApiData,
    StorageAreasForStorageFacilityListApiResponses
  >({
    getUrl: ({ storageFacilityId, ...queryParams }) =>
      apiUrl(`storage-facilities/${storageFacilityId}/storage-areas/`, queryParams)
  }),
  postStorageArea: responseEndpoint<StorageAreaCreateApiData, StorageAreaCreateApiResponses>({
    getUrl: () => apiUrl('storage-areas/'),
    getBody: (data) => data
  }),
  patchStorageArea: responseEndpoint<StorageAreaPatchApiData, StorageAreaPatchApiResponses>({
    getUrl: ({ storageAreaId }) => apiUrl(`storage-areas/${storageAreaId}/`),
    getBody: ({ storageAreaId: _, ...body }) => body
  }),
  deleteStorageArea: dataEndpoint<StorageAreaDeleteApiData, StorageAreaDeleteApiResponses>({
    getUrl: ({ storageAreaId }) => apiUrl(`storage-areas/${storageAreaId}/`)
  }),
  postStorageAreaUnitSpace: responseEndpoint<StorageAreaUnitSpaceSetApiData, StorageAreaUnitSpaceSetApiResponses>({
    getUrl: ({ storageAreaId }) => apiUrl(`storage-areas/${storageAreaId}/unit-space/`),
    getBody: ({ storageAreaId: _, ...body }) => body
  }),
  getStorageUnit: dataEndpoint<StorageUnitGetApiData, StorageUnitGetApiResponses>({
    getUrl: ({ storageUnitId }) => apiUrl(`storage-units/${storageUnitId}/`)
  }),
  getStorageUnits: dataEndpoint<StorageUnitListApiData, StorageUnitListApiResponses>({
    getUrl: (queryParams) => apiUrl('storage-units/', queryParams)
  }),
  postStorageUnit: responseEndpoint<StorageUnitCreateApiData, StorageUnitCreateApiResponses>({
    getUrl: () => apiUrl('storage-units/'),
    getBody: (data) => data
  }),
  patchStorageUnit: responseEndpoint<StorageUnitPatchApiData, StorageUnitPatchApiResponses>({
    getUrl: ({ storageUnitId }) => apiUrl(`storage-units/${storageUnitId}/`),
    getBody: ({ storageUnitId: _, ...body }) => body
  }),
  deleteStorageUnit: dataEndpoint<StorageUnitDeleteApiData, StorageUnitDeleteApiResponses>({
    getUrl: ({ storageUnitId }) => apiUrl(`storage-units/${storageUnitId}/`)
  }),
  getStorageUnitsForAreaFromIdentifier: dataEndpoint<
    StorageUnitsByAreaIdentifierListApiData,
    StorageUnitsByAreaIdentifierListApiResponses
  >({
    getUrl: ({ identifier, ...queryParams }) =>
      apiUrl(`storage-areas/identifier/${identifier}/storage-units/`, queryParams)
  }),
  postCreateStorageObjectForWheelsInBulk: responseEndpoint<
    StorageObjectGroupCreateForWheelSetsBulkApiData,
    StorageObjectGroupCreateForWheelSetsBulkApiResponses
  >({
    getUrl: () => apiUrl('storage-object-groups/create-for-wheel-sets/bulk/'),
    getBody: (data) => data
  }),
  getStorageObjectGroup: dataEndpoint<
    StorageObjectGroupGetByIdentifierApiData,
    StorageObjectGroupGetByIdentifierApiResponses
  >({
    getUrl: ({ storageObjectGroupIdentifier }) => apiUrl(`storage-object-groups/${storageObjectGroupIdentifier}/`)
  }),
  getStorageObjectGroupV2: dataEndpoint<StorageObjectGroupGetApiData, StorageObjectGroupGetApiResponses>({
    getUrl: ({ storageObjectGroupIdentifier }) => apiUrl(`storage-object-groups/${storageObjectGroupIdentifier}/v2/`)
  }),
  patchStorageObject: responseEndpoint<StorageObjectGroupPatchApiData, StorageObjectGroupPatchApiResponses>({
    getUrl: ({ storageObjectGroupIdentifier }) => apiUrl(`storage-object-groups/${storageObjectGroupIdentifier}/`),
    getBody: ({ storageObjectGroupIdentifier: _, ...body }) => body
  }),
  getStorageAreas: dataEndpoint<StorageAreaListApiData, StorageAreaListApiResponses>({
    getUrl: (queryParams) => apiUrl('storage-areas/', queryParams)
  }),
  getCarTiresForStorageObject: dataEndpoint<StorageObjectCarTiresApiData, StorageObjectCarTiresApiResponses>({
    getUrl: (queryParams) => apiUrl('storage-objects/car-tires/', queryParams)
  }),
  postMountTires: responseEndpoint<
    StorageMountTiresOnWheelsAtStorageFacilityApiData,
    StorageMountTiresOnWheelsAtStorageFacilityApiResponses
  >({
    getUrl: () => apiUrl('mount-tires-on-wheels-at-storage-facility/'),
    getBody: (data) => data
  }),
  getStorageObjectCarWheelSet: dataEndpoint<StorageObjectCarWheelsListApiData, StorageObjectCarWheelsListApiResponses>({
    getUrl: (queryParams) => apiUrl('storage-objects/car-wheels/', queryParams)
  }),
  getStorageObjectGroups: dataEndpoint<StorageObjectGroupListApiData, StorageObjectGroupListApiResponses>({
    getUrl: (queryParams) => apiUrl('storage-object-groups/', queryParams)
  }),
  getStorageObjectGroupCurrentIdentifiers: dataEndpoint<
    StorageObjectGroupCurrentIdentifiersApiData,
    StorageObjectGroupCurrentIdentifiersApiResponses
  >({
    getUrl: (queryParams) => apiUrl('storage-object-groups/current-identifiers/', queryParams)
  }),
  postMoveStorageObjectsInBulk: responseEndpoint<
    StorageObjectGroupPostBulkApiData,
    StorageObjectGroupPostBulkApiResponses
  >({
    getUrl: () => apiUrl('storage-object-groups/bulk/'),
    getBody: (data) => data
  }),
  getPaginatedStorageObjectGroupsV2: dataEndpoint<
    StorageObjectGroupListV2ApiData,
    StorageObjectGroupListV2ApiResponses
  >({
    getUrl: (queryParams) => apiUrl('storage-object-groups/v2/', storageObjectGroupsListQueryParamsForUrl(queryParams))
  }),
  getStorageObjectGroupListV2ToExcel: dataEndpoint<
    StorageObjectGroupListV2ToExcelApiData,
    StorageObjectGroupListV2ToExcelApiResponses
  >({
    getUrl: (queryParams) =>
      apiUrl('storage-object-groups/v2/to-excel/', storageObjectGroupsListQueryParamsForUrl(queryParams)),
    handleRes: async (res) => downloadToExcel(res),
    responseType: 'blob',
    sideEffectGet: true
  }),
  postWheelStorageCarChange: responseEndpoint<WheelStorageCarChangeApiData, WheelStorageCarChangeApiResponses>({
    getUrl: () => apiUrl('storage/wheel-storage/car-change/'),
    getBody: (data) => data
  }),
  getWheelStorageOverview: dataEndpoint<WheelStorageOverviewGetApiData, WheelStorageOverviewGetApiResponses>({
    getUrl: ({ serviceDepartmentIds }) => apiUrl('storage/wheel-storage/overview/', { serviceDepartmentIds })
  }),
  getPaginatedStorageCarWheelSets: dataEndpoint<StorageCarWheelSetListApiData, StorageCarWheelSetListApiResponses>({
    getUrl: (queryParams) => apiUrl('storage/car-wheel-sets/', queryParams)
  }),
  getPaginatedStorageObjectEvents: dataEndpoint<StorageObjectEventListApiData, StorageObjectEventListApiResponses>({
    getUrl: (queryParams) => apiUrl('storage-object-events/', queryParams)
  }),
  getPaginatedStorageObjectGroupEvents: dataEndpoint<
    StorageObjectGroupEventListApiData,
    StorageObjectGroupEventListApiResponses
  >({
    getUrl: ({ storageObjectGroupIdentifier, ...queryParams }) =>
      apiUrl(`storage-object-groups/${storageObjectGroupIdentifier}/events/`, queryParams)
  }),
  getStorageObjectGroupEvent: dataEndpoint<StorageObjectEventGetApiData, StorageObjectEventGetApiResponses>({
    getUrl: ({ storageObjectEventId }) => apiUrl(`storage-object-events/${storageObjectEventId}/`)
  }),
  getStorageObjectEventRetractPreview: dataEndpoint<
    StorageObjectEventRetractPreviewApiData,
    StorageObjectEventRetractPreviewApiResponses
  >({
    getUrl: ({ storageObjectEventId }) => apiUrl(`storage-object-events/${storageObjectEventId}/retract-preview/`)
  }),
  postRetractStorageObjectEvents: responseEndpoint<
    StorageObjectEventsRetractApiData,
    StorageObjectEventsRetractApiResponses
  >({
    getUrl: () => apiUrl('storage-object-events/retract/'),
    getBody: (data) => data
  }),
  postOpeningHoursStorageFacility: responseEndpoint<
    StorageFacilityOpeningHoursCreateApiData,
    StorageFacilityOpeningHoursCreateApiResponses
  >({
    getUrl: () => apiUrl('storage-facility/opening-hours/'),
    getBody: (data) => data
  }),
  postStorageFacilityGoogleOpeningHours: responseEndpoint<
    StorageFacilityGoogleOpeningHoursPostApiData,
    StorageFacilityGoogleOpeningHoursPostApiResponses
  >({
    getUrl: ({ storageFacilityId }) => apiUrl(`storage-facilities/${storageFacilityId}/google-opening-hours/`),
    getBody: ({ storageFacilityId: _, ...body }) => body
  }),
  postStorageFacilityPublicHolidayOpeningHours: responseEndpoint<
    StorageFacilityPublicHolidayOpeningHoursPostApiData,
    StorageFacilityPublicHolidayOpeningHoursPostApiResponses
  >({
    getUrl: ({ storageFacilityId }) => apiUrl(`storage-facilities/${storageFacilityId}/public-holiday-opening-hours/`)
  }),
  patchOpeningHoursStorageFacility: responseEndpoint<
    StorageFacilityOpeningHoursUpdateApiData,
    StorageFacilityOpeningHoursUpdateApiResponses
  >({
    getUrl: ({ pk }) => apiUrl(`storage-facility/opening-hours/${pk}/`),
    getBody: ({ pk: _, ...body }) => body
  }),
  getWheelStorageForCustomer: dataEndpoint<WheelStorageForCustomerListApiData, WheelStorageForCustomerListApiResponses>(
    {
      getUrl: (queryParams) => apiUrl('storage/car-wheel-sets/for-customer/', queryParams)
    }
  ),
  postStorageObjectFromInventoryOrder: responseEndpoint<
    StorageObjectCreateForTireQuoteApiData,
    StorageObjectCreateForTireQuoteApiResponses
  >({
    getUrl: () => apiUrl('storage-object-groups/tire-quote-inventory-order/'),
    getBody: (data) => data
  }),
  postInventoryOrdersReceive: responseEndpoint<
    StorageObjectGroupsInventoryOrdersReceiveApiData,
    StorageObjectGroupsInventoryOrdersReceiveApiResponses
  >({
    getUrl: () => apiUrl('storage-object-groups/inventory-orders/receive/'),
    getBody: (data) => data
  }),
  getInventoryOrdersForTireQuote: dataEndpoint<
    ShopInventoryOrderCarTireQuotesListApiData,
    ShopInventoryOrderCarTireQuotesListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('inventory-orders/car-tire-quotes/', queryParams)
  }),
  getStorageObjectsToExcel: dataEndpoint<
    StorageUnitObjectsExcelDownloadApiData,
    StorageUnitObjectsExcelDownloadApiResponses
  >({
    getUrl: ({ storageUnitId, ...queryParams }) =>
      apiUrl(`storage-units/${storageUnitId}/storage-objects-to-excel/`, queryParams),
    handleRes: async (res) => downloadToExcel(res),
    responseType: 'blob',
    sideEffectGet: true
  }),
  postCreateStorageTransferOrder: responseEndpoint<
    StorageTransferOrderCreateApiData,
    StorageTransferOrderCreateApiResponses
  >({
    getUrl: () => apiUrl('storage-transfer-orders/'),
    getBody: (data) => data
  }),
  postCreateStorageTransferOrdersBulk: responseEndpoint<
    StorageTransferOrderBulkCreateApiData,
    StorageTransferOrderBulkCreateApiResponses
  >({
    getUrl: () => apiUrl('storage-transfer-orders/bulk/'),
    getBody: (data) => data
  }),
  getPaginatedStorageTransferOrders: dataEndpoint<
    StorageTransferOrderListApiData,
    StorageTransferOrderListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('storage-transfer-orders/', queryParams)
  }),
  getPaginatedStorageObjectGroupsWithBookingInfo: dataEndpoint<
    StorageObjectGroupWithBookingInfoListApiData,
    StorageObjectGroupWithBookingInfoListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('storage-object-groups/with-booking-info/', queryParams)
  }),
  getStorageObjectGroupTransferSuggestions: dataEndpoint<
    StorageObjectGroupTransferSuggestionsApiData,
    StorageObjectGroupTransferSuggestionsApiResponses
  >({
    getUrl: (queryParams) => apiUrl('storage-object-groups/transfer-suggestions/', queryParams)
  }),
  postStorageObjectGroupsByIdentifiersDetails: responseEndpoint<
    StorageObjectGroupByIdentifiersDetailsApiData,
    StorageObjectGroupByIdentifiersDetailsApiResponses
  >({
    getUrl: () => apiUrl('storage-object-groups/by-identifiers/details/'),
    getBody: (data) => data
  }),
  getStorageTransferOrder: dataEndpoint<StorageTransferOrderGetApiData, StorageTransferOrderGetApiResponses>({
    getUrl: ({ storageTransferOrderId }) => apiUrl(`storage-transfer-orders/${storageTransferOrderId}/`)
  }),
  getStorageTransferTimingPreview: dataEndpoint<
    StorageTransferTimingPreviewApiData,
    StorageTransferTimingPreviewApiResponses
  >({
    getUrl: (queryParams) => apiUrl('storage-transfer-orders/timing-preview/', queryParams)
  }),
  patchStorageTransferOrder: responseEndpoint<
    StorageTransferOrderUpdateApiData,
    StorageTransferOrderUpdateApiResponses
  >({
    getUrl: ({ storageTransferOrderId }) => apiUrl(`storage-transfer-orders/${storageTransferOrderId}/`),
    getBody: ({ storageTransferOrderId: _, ...body }) => body
  }),
  patchStorageTransferOrderItems: responseEndpoint<
    StorageTransferOrderItemsUpdateApiData,
    StorageTransferOrderItemsUpdateApiResponses
  >({
    getUrl: ({ storageTransferOrderId }) => apiUrl(`storage-transfer-orders/${storageTransferOrderId}/items/`),
    getBody: ({ storageTransferOrderId: _, ...body }) => body
  }),
  patchStorageTransferOrderItemUnableToCompleteClear: responseEndpoint<
    StorageTransferOrderItemUnableToCompleteClearApiData,
    StorageTransferOrderItemUnableToCompleteClearApiResponses
  >({
    getUrl: ({ storageTransferOrderId, storageTransferOrderItemId }) =>
      apiUrl(
        `storage-transfer-orders/${storageTransferOrderId}/items/${storageTransferOrderItemId}/unable-to-complete/clear/`
      ),
    getBody: () => ({})
  }),
  patchStorageTransferOrderItemsUnableToCompleteBulk: responseEndpoint<
    StorageTransferOrderItemsUnableToCompleteBulkApiData,
    StorageTransferOrderItemsUnableToCompleteBulkApiResponses
  >({
    getUrl: ({ storageTransferOrderId }) =>
      apiUrl(`storage-transfer-orders/${storageTransferOrderId}/items/unable-to-complete/bulk/`),
    getBody: ({ storageTransferOrderId: _, ...body }) => body
  }),
  postStorageTransferOrderItemOutcome: responseEndpoint<
    StorageTransferOrderItemOutcomeSetApiData,
    StorageTransferOrderItemOutcomeSetApiResponses
  >({
    getUrl: ({ storageTransferOrderId, storageTransferOrderItemId }) =>
      apiUrl(`storage-transfer-orders/${storageTransferOrderId}/items/${storageTransferOrderItemId}/outcome/`),
    getBody: ({ storageTransferOrderId: _, storageTransferOrderItemId: __, ...body }) => body
  }),
  postCancelStorageTransferOrder: responseEndpoint<
    StorageTransferOrderCancelApiData,
    StorageTransferOrderCancelApiResponses
  >({
    getUrl: ({ storageTransferOrderId }) => apiUrl(`storage-transfer-orders/${storageTransferOrderId}/cancel/`),
    getBody: ({ storageTransferOrderId: _, ...body }) => body
  }),
  deleteStorageTransferOrder: dataEndpoint<StorageTransferOrderDeleteApiData, StorageTransferOrderDeleteApiResponses>({
    getUrl: ({ storageTransferOrderId }) => apiUrl(`storage-transfer-orders/${storageTransferOrderId}/`)
  }),
  getStorageTransferOrderFacilityLinkPublic: dataEndpoint<
    StorageTransferOrderFacilityLinkPublicGetApiData,
    StorageTransferOrderFacilityLinkPublicGetApiResponses
  >({
    getUrl: ({ slug }) => apiUrl(`storage-transfer-orders/public/${slug}/facility-link/`)
  }),
  getFacilityTransferDayPublic: dataEndpoint<
    FacilityTransferDayPublicGetApiData,
    FacilityTransferDayPublicGetApiResponses
  >({
    getUrl: ({ publicSlug, ...queryParams }) =>
      apiUrl(`storage-facilities/public/${publicSlug}/transfers/`, queryParams)
  }),
  patchFacilityTransferExternalCheckBulkPublic: responseEndpoint<
    FacilityTransferExternalCheckBulkPublicApiData,
    FacilityTransferExternalCheckBulkPublicApiResponses
  >({
    getUrl: ({ publicSlug }) => apiUrl(`storage-facilities/public/${publicSlug}/items/external-check/`),
    getBody: ({ publicSlug: _, ...body }) => body
  }),
  postStorageTransferOrderDispatch: responseEndpoint<
    StorageTransferOrderDispatchApiData,
    StorageTransferOrderDispatchApiResponses
  >({
    getUrl: ({ storageTransferOrderId }) => apiUrl(`storage-transfer-orders/${storageTransferOrderId}/dispatch/`),
    getBody: ({ storageTransferOrderId: _, ...body }) => body
  }),
  postStorageTransferOrderDispatchPreview: responseEndpoint<
    StorageTransferOrderDispatchPreviewApiData,
    StorageTransferOrderDispatchPreviewApiResponses
  >({
    getUrl: () => apiUrl('storage-transfer-orders/dispatch/preview/'),
    getBody: (data) => data
  }),
  postStorageTransferOrderDispatchPreviewForOrder: responseEndpoint<
    StorageTransferOrderDispatchPreviewForOrderApiData,
    StorageTransferOrderDispatchPreviewForOrderApiResponses
  >({
    getUrl: ({ storageTransferOrderId }) =>
      apiUrl(`storage-transfer-orders/${storageTransferOrderId}/dispatch/preview/`),
    getBody: ({ storageTransferOrderId: _, ...body }) => body
  }),
  postStorageTransferOrderAddWheelSets: responseEndpoint<
    StorageTransferOrderAddWheelSetsApiData,
    StorageTransferOrderAddWheelSetsApiResponses
  >({
    getUrl: ({ storageTransferOrderId }) => apiUrl(`storage-transfer-orders/${storageTransferOrderId}/add-wheel-sets/`),
    getBody: ({ storageTransferOrderId: _, ...body }) => body
  }),
  postStorageTransferOrderAddWheelSetsPreview: responseEndpoint<
    StorageTransferOrderAddWheelSetsPreviewApiData,
    StorageTransferOrderAddWheelSetsPreviewApiResponses
  >({
    getUrl: ({ storageTransferOrderId }) =>
      apiUrl(`storage-transfer-orders/${storageTransferOrderId}/add-wheel-sets/preview/`),
    getBody: ({ storageTransferOrderId: _, ...body }) => body
  }),
  getPaginatedStorageCountSessions: dataEndpoint<StorageCountSessionListApiData, StorageCountSessionListApiResponses>({
    getUrl: (queryParams) => apiUrl('storage/count-sessions/', queryParams)
  }),
  getStorageCountSession: dataEndpoint<StorageCountSessionGetApiData, StorageCountSessionGetApiResponses>({
    getUrl: ({ countSessionId }) => apiUrl(`storage/count-sessions/${countSessionId}/`)
  }),
  postStorageCountSession: responseEndpoint<StorageCountSessionCreateApiData, StorageCountSessionCreateApiResponses>({
    getUrl: () => apiUrl('storage/count-sessions/'),
    getBody: (data) => data
  }),
  getPaginatedStorageCountLines: dataEndpoint<StorageCountLineListApiData, StorageCountLineListApiResponses>({
    getUrl: ({ countSessionId, ...queryParams }) =>
      apiUrl(`storage/count-sessions/${countSessionId}/lines/`, queryParams)
  }),
  postStorageCountLineScan: responseEndpoint<StorageCountLineScanApiData, StorageCountLineScanApiResponses>({
    getUrl: ({ countSessionId }) => apiUrl(`storage/count-sessions/${countSessionId}/scans/`),
    getBody: ({ countSessionId: _, ...body }) => body
  }),
  postStorageCountSessionComplete: responseEndpoint<
    StorageCountSessionCompleteApiData,
    StorageCountSessionCompleteApiResponses
  >({
    getUrl: ({ countSessionId }) => apiUrl(`storage/count-sessions/${countSessionId}/complete/`)
  }),
  postStorageCountSessionCancel: responseEndpoint<
    StorageCountSessionCancelApiData,
    StorageCountSessionCancelApiResponses
  >({
    getUrl: ({ countSessionId }) => apiUrl(`storage/count-sessions/${countSessionId}/cancel/`)
  }),
  getPaginatedLabelPrintRequests: dataEndpoint<LabelPrintRequestListApiData, LabelPrintRequestListApiResponses>({
    getUrl: (queryParams) => apiUrl('storage/label-print-requests/', queryParams)
  }),
  postStorageObjectGroupLabelReplaced: responseEndpoint<StorageLabelReplacedApiData, StorageLabelReplacedApiResponses>({
    getUrl: ({ storageObjectGroupIdentifier }) =>
      apiUrl(`storage-object-groups/${storageObjectGroupIdentifier}/label-replaced/`)
  }),
  postLabelPrintRequests: responseEndpoint<LabelPrintRequestCreateApiData, LabelPrintRequestCreateApiResponses>({
    getUrl: () => apiUrl('storage/label-print-requests/'),
    getBody: (data) => data
  }),
  postLabelPrintRequestsMarkPrinted: responseEndpoint<
    LabelPrintRequestMarkPrintedApiData,
    LabelPrintRequestMarkPrintedApiResponses
  >({
    getUrl: () => apiUrl('storage/label-print-requests/mark-printed/'),
    getBody: (data) => data
  }),
  postLabelPrintRequestsCancel: responseEndpoint<LabelPrintRequestCancelApiData, LabelPrintRequestCancelApiResponses>({
    getUrl: () => apiUrl('storage/label-print-requests/cancel/'),
    getBody: (data) => data
  }),
  ...getUnlockUrls
};
